import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BarChartOptions } from 'chart.js';
import { List } from 'immutable';
import { BarChart } from '../../bar-chart.model';
import { Dataset } from '../../sub-models/dataset.model';
import { BarChartBuilder } from './bar-chart.builder';
import {
  I2gNgTrackingActionBuilder,
  ITrackingObject,
  ITrackingProperties,
} from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { NavigationBuilder } from '../../../navigation/navigation.builder';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';
import { IDeepLinkProperties } from '../../../navigation/deep-link-properties.interface';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [BarChartBuilder],
})
export class BarChartComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() barChart: BarChart;
  @Input() options: BarChartOptions;
  @Input() height = 200;

  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingAdditionalProperties: ITrackingProperties;

  @ViewChild('chartCanvas', { static: true }) chartCanvas: ElementRef;

  private _el: any;
  private _datasets: List<Dataset>;
  private _labels: string[];
  private _highlight: number;
  private _baseline: number;

  constructor(
    private _barChartBuilder: BarChartBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingDispatcher: TrackingDispatcher,
    private _navigationBuilder: NavigationBuilder
  ) {}

  ngOnChanges(changes) {
    if (changes.barChart && this.barChart) {
      const barChart: BarChart = this.barChart;

      this._labels = barChart.labels.toArray();
      this._datasets = barChart.datasets;
      this._highlight = barChart.highlight;
      this._baseline = barChart.baseline;

      this.drawChart();
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this._el = this.chartCanvas.nativeElement;

    this.drawChart();
  }

  drawChart() {
    if (this._el) {
      this._barChartBuilder.buildBarChart(
        this._el,
        this._datasets,
        this._labels,
        this._highlight,
        this._baseline,
        this.options,
        this.trackChartClick.bind(this)
      );
    }
  }

  trackChartClick(deeplinkUrl: string) {
    const deepLinkProperties: IDeepLinkProperties = this._navigationBuilder.buildDeepLinkProperties(
      deeplinkUrl
    );
    const trackingAction = this._trackingActionBuilder.buildChartTapped(
      'report_list',
      this.trackingScreenName
    );

    this._trackingDispatcher.trackEvent(this.trackingObject, trackingAction, {
      ...deepLinkProperties.params,
      ...this.trackingAdditionalProperties,
    });
  }
}
